import { createContext, useContext } from "react";
import { DEFAULT_PAGE_SIZE } from "@circle-react/hooks/useAllWorkflowsInfiniteQuery";

interface WorkflowsContextProp {
  category?: "paywalls" | "onboarding" | "administrative";
  onClose?: () => void;
  pageSize?: number;
  shouldAutoAdjust?: boolean;
}

export interface WorkflowsDataProviderProp extends WorkflowsContextProp {
  children: any;
}

const WorkflowsData = createContext<WorkflowsContextProp>({
  pageSize: DEFAULT_PAGE_SIZE,
});
WorkflowsData.displayName = "WorkflowsData";

export const useWorkflowsData = () => useContext(WorkflowsData);

export const WorkflowsDataProvider = ({
  children,
  pageSize = DEFAULT_PAGE_SIZE,
  category,
  onClose,
  shouldAutoAdjust,
}: WorkflowsDataProviderProp) => {
  const valuesToStore = { pageSize, category, onClose, shouldAutoAdjust };

  return (
    <WorkflowsData.Provider value={valuesToStore}>
      {children}
    </WorkflowsData.Provider>
  );
};
